import {ChangeEvent, FC, useEffect} from "react";

import {KCTEventDto} from "../../types/contracts";
import {useAdminEventConfigurator} from "../../hooks";
import {
  AccommodationTypesComponent,
  EventDetailsComponent,
  FeeTypesComponent,
  ServicesComponent,
} from "../form-components-event";
import {AdminPageCard} from "./AdminPageCard";
import {useEventsContext} from "../../providers/EventsProvider";

export const AdminEventConfigurator: FC = () => {
  const {
    events,
    setSelectedEventId,
    selectedEventId
  } = useEventsContext()

  const adminEventConfigurator = useAdminEventConfigurator();

  useEffect(() => {
    if(selectedEventId) {
      adminEventConfigurator.loadSpecificEvent(selectedEventId);
    }
  }, [selectedEventId]);

  const onSelect = (id: string) => {
    setSelectedEventId(id);
    adminEventConfigurator.loadSpecificEvent(id);
  };

  return (
    <AdminPageCard title="Konfigurace události" className="max-w-3xl">
      {/* Load Existing Events */}
      <div className="mb-6">
        <label className="block mb-2 font-semibold" htmlFor="existing-events">
          Načtené existující události
        </label>
        <select
          id="existing-events"
          onChange={(e: ChangeEvent<HTMLSelectElement>) =>
            onSelect(e.target.value)
          }
          className="w-full p-2 border border-gray-300 rounded-md"
          value={selectedEventId || ""}
        >
          <option value="">Vyberte událost pro úpravu/vytvořte novou</option>
          {events && events.map((evt: KCTEventDto) => (
            <option key={evt.id} value={evt.id}>
              {evt.name}
            </option>
          ))}
        </select>
      </div>

      <form onSubmit={adminEventConfigurator.handleSubmit}>
        {/* Event Details */}
        <EventDetailsComponent
          event={adminEventConfigurator.event!}
          handleEventChange={adminEventConfigurator.handleEventChange}
          handleDatesChange={adminEventConfigurator.handleDatesChange}
        />

        {/* Accommodation Types Section */}
        <AccommodationTypesComponent
          accommodationTypes={adminEventConfigurator.accommodationTypes}
          handleAccommodationTypeChange={
            adminEventConfigurator.handleAccommodationTypeChange
          }
          removeAccommodationType={
            adminEventConfigurator.removeAccommodationType
          }
          addAccommodationType={adminEventConfigurator.addAccommodationType}
          currency={adminEventConfigurator.event?.currency}
          submittedAccommodationTypes={adminEventConfigurator.submittedAccommodationTypes}
        />

        {/* Additional Services */}
        <ServicesComponent
          services={adminEventConfigurator.services}
          handleServiceChange={adminEventConfigurator.handleServiceChange}
          handleCheckboxChange={adminEventConfigurator.handleCheckboxChange}
          removeService={adminEventConfigurator.removeService}
          addService={adminEventConfigurator.addService}
          currency={adminEventConfigurator.event?.currency}
        />

        {/* Fee Types Section */}
        <FeeTypesComponent
          feeTypes={adminEventConfigurator.feeTypes}
          handleFeeTypeChange={adminEventConfigurator.handleFeeTypeChange}
          handleFeeCheckboxChange={
            adminEventConfigurator.handleFeeCheckboxChange
          }
          removeFeeType={adminEventConfigurator.removeFeeType}
          addFeeType={adminEventConfigurator.addFeeType}
          handleFormFieldsChange={adminEventConfigurator.handleFormFieldsChange}
          currency={adminEventConfigurator.event?.currency}
        />

        <div className="sticky bottom-0 mt-6 pt-4 pb-4 bg-gradient-to-b from-white/0 via-white/95 to-white">
          <div className="flex justify-end">
            <button
              type="submit"
              className="px-6 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 min-w-[120px]"
            >
              Uložit
            </button>
          </div>
        </div>
      </form>
    </AdminPageCard>
  );
};
